export default "__VITE_ASSET__C2ha6A8z__"